import MovingForwardCommunication from '~/pages/communication/movingForward/libs/components/MovingForwardCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const MovingForwardCommunicationPage = (props: TPageProps) => (
  <MovingForwardCommunication {...props} />
)

export default MovingForwardCommunicationPage
